/* eslint-disable indent */
import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Isvg from 'react-inlinesvg'
import { Tab, Row, Nav, PanelGroup, Panel, NavItem } from 'react-bootstrap'
import { browserHistory } from 'react-router'
import styled, { withTheme, css } from 'styled-components'
import { Helmet } from 'react-helmet'
import scrollToElement from 'scroll-to-element'
import OptionsHOC from '../../hocs/OptionsHOC'
import { MoreHelpFooterContainer } from '../../containers'
import contentTypes from '../../constants/content-types'
import { customerNames } from '../../constants/static-data'
import { slugify, trimString, faqStructuredData } from '../../helpers/utils'
import { ContentFilter, QuickFeedback } from '..'
import SEO from '../SEO'
import AirfindAd from '../AirfindAd'
import { messages } from './messages'
import { useAppContext } from '../../containers/App/Context'


const v4 = css`
  --expressHelpAccentColor: #ee0000;
  .nav-primary {
    li {
      border: 1px solid var(--clr-accent-to-white);
      &.active {
        border-top: 3px solid var(--expressHelpAccentColor);
        a svg {
          fill: var(--clr-accent-to-white);
          background: none;
        }
        a .primary-category-tab {
          border-bottom: none;
        }
        a .primary-category-tab:after {
          display: none;
        }
      }
      a {
        color: var(--clr-accent-to-white);
        svg {
          fill: var(--clr-accent-to-white);
          background: none;
        }
      }
    }
  }
  .nav-sub {
    border-bottom: 1px solid var(--clr-grey-6-to-text);
    li,
    li.active {
      a,
      a:hover {
        background: none;
        color: var(--clr-grey-3-to-white);
        font-weight: 700;
      }
    }
    li.active {
      a {
        color: var(--clr-accent-to-white);
        border-bottom: 4px solid var(--expressHelpAccentColor);
        border-radius: unset;
      }
    }
  }
  .faq-list {
    padding: 5px 10%;
    .panel-default {
      border-bottom: 0;
      border-top: 1px solid var(--clr-grey-6-to-text);
    }
    .panel-heading {
      a {
        border-bottom: none;
      }
      a,
      a:hover {
        color: var(--clr-accent-to-white);
        font-size: var(--base);
      }
      & .collapsed {
        color: var(--clr-accent-to-white);
        font-weight: 700;
        border-bottom: 0;
      }
    }
    .panel-body {
      padding: 22px 30px;
      color: var(--clr-accent-to-white);
      a {
        color: var(--clr-accent-to-white);
      }
    }
  }
  .nav-pills {
    li {
      margin-bottom: 0;
    }
  }
  @media screen and (max-width: 767px) {
    --express-category-width: 170px;
    --express-category-height: var(--express-category-width);
    --express-svg-height: 70%;
    --express-svg-width: 90%;
    .nav-primary {
      li {
        a .primary-category-tab {
          flex-direction: column;
          text-align: center;
          justify-content: space-evenly;
          svg {
            padding: 10px;
          }
        }
      }
    }
    .nav-pills {
    li {
      margin: var(--2xs);
    }
  }
  }
`

export const Wrapper = styled.div`
  --express-category-width: 170px;
  --express-category-height: var(--express-category-width);
  --express-svg-height: 70%;
  --express-svg-width: 90%;
  .nav-primary {
    flex-wrap: wrap;
    li {
      width: var(--express-category-width);
      height: var(--express-category-height);
      a {
        padding: 0;
        height: 100%;
        width: 100%;
        cursor: pointer;
        background: none;
        color: var(--clr-grey-5-to-text);
        font-weight: bold;
        transition: all 0.5s;
        &:hover {
          color: var(--clr-accent);
          background-color: transparent;
        }
        svg {
          fill: var(--clr-grey-3-to-text);
          &:hover {
            fill: var(--clr-accent);
          }
        }
      }
      &.active {
        a {
          color: var(--clr-accent-to-white);
          .primary-category-tab {
            border-bottom: 2px solid var(--clr-accent);
            &:after {
              content: '';
              border-right-color: transparent;
              border-bottom-color: transparent;
              border-left-color: transparent;
              border-style: solid;
              border-width: 5px;
              width: 0;
              height: 0;
              position: absolute;
              bottom: -10px;
              left: 50%;
            }
          }
          svg {
            fill: var(--clr-nav-text);
            background-color: var(--clr-accent);
            border-radius: 7px;
          }
        }
      }
    }
  }
  .nav-pills {
    li {
      margin: 10px 15px;
    }
  }
  .primary-category-tab {
    width: 100%;
    height: 100%;
    &:after {
      color: var(--clr-accent);
    }
    p {
      padding: 0 var(--2xs);
    }
    svg {
      height: var(--express-svg-height);
      width: var(--express-svg-width);
      min-width: var(--5xl);
      padding: 10px;
      fill: #686868;
      transition: all 0.5s;
    }
  }
  .nav-sub {
    text-align: center;
    margin: 25px 25px 40px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    li {
      flex: 1 1 auto;
      max-width: max-content;
      a {
        background: var(--clr-grey-7-to-text);
        color: var(--clr-grey-3-to-white);
        cursor: pointer;
        &:hover {
          color: var(--clr-accent);
        }
      }
    }
    li.active {
      a {
        background: var(--clr-accent);
        color: var(--white);
      }
    }
  }
  .faq-list {
    padding: 5px 25px;
    .panel-default {
      border: none;
      border-bottom: 1px solid var(--clr-grey-6-to-text);
      border-radius: 0;
      background-color: var(--clr-bg);
    }
    .panel-heading {
      background: none;
      padding: 0;
      color: var(--clr-accent-to-black);
      cursor: pointer;
      & .collapsed {
        color: var(--clr-grey-3-to-white);
        font-weight: 400;
        border-bottom: 0;
        &:hover {
          color: var(--clr-accent);
        }
      }
      a {
        display: inline-block;
        padding: 15px 45px;
        border-bottom: 1px solid var(--clr-grey-6-to-text);
        width: 100%;
        text-decoration: none !important;
        color: var(--clr-accent);
        font-size: var(--h5);
        font-weight: 700;
        &:hover {
          color: var(--clr-accent);
        }
        &:after {
          font-family: 'FontAwesome';
          content: '\f077';
          float: right;
          transition: transform 300ms;
          font-weight: 400;
          color: var(--clr-accent);
        }
      }
    }
    .panel-body {
      padding: 22px 90px;
      color: var(--clr-grey-4-to-white);
      background: var(--clr-grey-7-to-black);
      font-size: var(--h5);
      a {
        color: var(--clr-grey-3-to-accent);
      }
    }
  }
  .panel-default > .panel-heading + .panel-collapse > .panel-body {
    border: 0;
    margin: 20px 50px;
  }
  @media (max-width: 767px) {
    --express-category-width: 40%;
    --express-category-height: 43px;
    --express-svg-height: 100%;
    --express-svg-width: 10%;
    .nav-primary {
      li {
        border: none;
        padding: 0 var(--2xs);
        a .primary-category-tab {
          display: flex;
          align-items: center;
          justify-content: flex-start;
          text-align: start;
          svg {
            padding: 5px 0;
          }
          p {
            margin: 0;
          }
        }
        &.active {
          a svg {
            fill: var(--clr-accent-to-white);
            background: none;
          }
          a .primary-category-tab {
            border-bottom: none;
          }
          a .primary-category-tab:after {
            display: none;
          }
        }
      }
    }
    .nav-sub {
      margin: 0 0 15px 0;
      li a {
        padding: 5px 10px;
      }
    }
    .sub-category-tab {
      font-size: 0.9rem;
    }
    .faq-list {
      .panel-heading a {
        padding: var(--1xs);
      }
      .panel-body {
        padding: var(--1xs);
      }
    }
  }
  ${props => props.version === 'v4' && v4}
`

const ExpressContent = ({
  params,
  currentPhone,
  toggleDeviceModal,
  query,
  createUserEvent,
  expressCategories,
  location,
  language,
  getOption,
  customer
}) => {
  const [activeCategoryIndex, setActiveCategoryIndex] = useState()
  const [activeSubcategoryIndex, setActiveSubcategoryIndex] = useState()
  const [legacyUrlChecked, setLegacyUrlChecked] = useState(false)
  const [activeFaq, setActiveFaq] = useState()
  const [allFaqs, setAllFaqs] = useState([])
  const { versionKey: version } = useAppContext()

  // Variable to handle the visibility of AirfindAd in a specific location. See L573
  const showAdTop = getOption('ad.showAdTop')

  const locationSubcatIndex = location.state?.subcategoryIndex

  useEffect(() => {
    const allFaqs = getAllFaqs(expressCategories)
    // redirect from legacy url
    if (/^\d+$/.test(params?.category) && params?.category.length === 7) {
      const faq = allFaqs.find(item => parseInt(item.pk, 10) === parseInt(params.category, 10))
    
      if (faq) {
        browserHistory.replace({
        pathname: `/expresshelp/${slugify(faq.category)}/${slugify(faq.name)}`,
        query
        })
      }
    } 

    setAllFaqs(allFaqs)
  }, [expressCategories.length, params])

  useEffect(() => {
    if (allFaqs.length === 0) {
      return
    }

    setLegacyUrlChecked(true)

    const { id, category } = params
    
    const faq = getActiveFaq(allFaqs, category, id)
    const catIndex = getCategoryIndex(faq, category, expressCategories)
    const subcatIndex = getSubcategoryIndex(faq, locationSubcatIndex)

    // when category or faq does not exist fall back to the last parent
    if ((params.id && !faq) || catIndex === -1) {
      return browserHistory.push({
        pathname: `/expresshelp`,
        query
      })
    }
    if (faq && faq.name) {
      scrollToActive(slugify(faq.name))
    }

    setActiveFaq(faq)
    setActiveCategoryIndex(catIndex)
    setActiveSubcategoryIndex(subcatIndex)
  }, [
    allFaqs.length,
    params.category,
    params.id,
    locationSubcatIndex,
    expressCategories.length
  ])

  // When no FAQ is selected, structured data is populated with the static data
  const getStaticStructuredData = category => {
    const name = customerNames[customer] || customer
    const translated = messages[language]
    const staticText = translated[category] || category

    return {
      question: `${name} Express Help ${staticText}`,
      answer: `${name} Frequently Asked Questions ${staticText}`
    }
  }

  const getAllFaqs = expressCategories =>
    expressCategories.flatMap((cat, catIndex) =>
      cat.children.flatMap((subcat, subcatIndex) =>
        subcat.children.map((faq, faqIndex) => ({
          ...faq,
          faqIndex,
          category: cat.name,
          categoryIndex: catIndex,
          subcategory: subcat.name,
          subcategoryIndex: subcatIndex
        }))
      )
    )

  const getActiveFaq = (allFaqs, categoryParam, idParam) =>
    allFaqs.find(faq => {
      const faqPk = parseInt(faq.pk, 10)

      const legacyUrlMatch = faqPk === parseInt(categoryParam, 10)
      const faqPkMatch = faqPk === parseInt(idParam, 10)
      const slugMatch =
        faq.name &&
        slugify(faq.name) === idParam &&
        categoryParam === slugify(faq.category)

      return legacyUrlMatch || faqPkMatch || slugMatch
    })

  const getCategoryIndex = (activeFaq, categoryParam, expressCategories) => {
    if (!categoryParam) {
      return 0
    }
    if (activeFaq) {
      return activeFaq.categoryIndex
    }

    return expressCategories.findIndex(
      cat => slugify(cat.name) === categoryParam
    )
  }

  const getSubcategoryIndex = (activeFaq, locationSubcatIndex) => {
    if (activeFaq) {
      return activeFaq.subcategoryIndex
    }
    if (locationSubcatIndex) {
      return locationSubcatIndex
    }
    return 0
  }

  const onPrimaryNav = (category, index) => {
    const categoryNameSlug = slugify(category.name)
    createUserEvent({
      category: 'landing',
      data: { action: 'TogglePrimaryCategory', target: category.name }
    })

    if (!category.acadLink || (category.acadLink && currentPhone)) {
      browserHistory.push({
        pathname: category.acadLink
          ? '/devicehome'
          : `/expresshelp/${categoryNameSlug}`,
        state: { categoryIndex: index },
        query
      })
    } else if (!currentPhone) {
      toggleDeviceModal()
      browserHistory.push({
        pathname: `/expresshelp/${categoryNameSlug}`,
        state: { categoryIndex: index },
        query
      })
    }
  }

  const onSubNav = (index, subindex, subcategory) => {
    const [firstCategory] = expressCategories
    const categoryNameSlug = slugify(firstCategory.name)
    const category = params.category || categoryNameSlug
    createUserEvent({
      category: 'landing',
      data: { action: 'ToggleSecondaryCategory', target: subcategory.name }
    })

    browserHistory.push({
      pathname: `/expresshelp/${category}`,
      state: { categoryIndex: index, subcategoryIndex: subindex },
      query
    })
  }

  const onPrimaryNavClick = (category, index) => {
    onPrimaryNav(category, index)
  }

  const onPrimaryNavKeyPress = (index, e) => {
    const { keyCode } = e

    if (keyCode === 37) {
      index = index === 0 ? expressCategories.length - 1 : index - 1
      onPrimaryNav(expressCategories[index], index)
    } else if (keyCode === 39) {
      index = index === expressCategories.length - 1 ? 0 : index + 1
      onPrimaryNav(expressCategories[index], index)
    }
  }

  const onSubNavClick = (index, subindex, subcategory) => {
    onSubNav(index, subindex, subcategory)
  }

  const onSubNavKeyPress = (index, subindex, e) => {
    const { keyCode } = e
    const category = expressCategories[index]

    if (keyCode === 37) {
      subindex = subindex === 0 ? category.children.length - 1 : subindex - 1
      onSubNav(index, subindex, category.children[subindex])
    } else if (keyCode === 39) {
      subindex = subindex === category.children.length - 1 ? 0 : subindex + 1
      onSubNav(index, subindex, category.children[subindex])
    }
  }

  const onFaqSelect = (faq, categoryName) => {
    browserHistory.replace({
      pathname: `/expresshelp/${slugify(categoryName)}/${slugify(faq.name)}`,
      query
    })

    createUserEvent({
      category: 'landing',
      data: { action: 'ToggleSingleFAQ', target: faq.pk }
    })

    createUserEvent({
      category: 'faqs',
      data: { action: 'ToggleSingleFAQ', target: faq.pk }
    })
  }

  const scrollToActive = slug => {
    setTimeout(function() {
      window.requestAnimationFrame(function() {
        scrollToElement(`[data-slug="${slug}"]`, {
          offset: 0,
          duration: 500
        })
      })
    }, 0)
  }

  const onSvgLoad = index => {
    document.querySelector(`#primary-category-tab-${index} svg`)?.setAttribute('focusable', 'false')
  }

  const isLoading =
    !expressCategories.length || activeCategoryIndex === undefined

  if (isLoading || !legacyUrlChecked) {
    return <div>Loading...</div>
  }
  const faqId = activeFaq && activeFaq.pk
  const categoryName = expressCategories[activeCategoryIndex].name
  const getTitle = () => {
    if (activeFaq) {
      return `${activeFaq.name} ${contentTypes[language].faq}`
    }
    return `${categoryName} FAQ ${
      customerNames[customer] ? `- ${customerNames[customer]}` : ''
    }`
  }
  const description = activeFaq
    ? trimString(activeFaq.val, 120)
    : `Browse our FAQs to get more information on the ${expressCategories[activeCategoryIndex].name}.`

  return (
    <div className="animated fadeIn">
      <SEO
        title={getTitle()}
        description={description}
        script={
          activeFaq && activeFaq.name
            ? faqStructuredData([
                {
                  question: activeFaq && activeFaq.name,
                  answer: activeFaq && activeFaq.val
                }
              ])
            : faqStructuredData([getStaticStructuredData(categoryName)])
        }
      />
      <Helmet>
        <link
          rel="canonical"
          href={`${window.location.origin}${window.location.pathname}${
            language !== 'en' ? `?lang=${language}` : ''
          }`}
        />
      </Helmet>
      <Wrapper id="landing-page" key={Math.uuid()} version={version}>
        <Tab.Container
          defaultActiveKey={`category_${activeCategoryIndex}`}
          id="primary-container"
        >
          <div>
              <Nav bsClass="nav nav-pills nav-justified nav-primary flex">
                {expressCategories.map((category, index) => (
                  <NavItem
                    componentClass="a"
                    eventKey={`category_${index}`}
                    key={`primary_${index}`}
                    onClick={() => onPrimaryNavClick(category, index)}
                    onKeyDown={e => onPrimaryNavKeyPress(index, e)}
                  >
                    <div
                      className="primary-category-tab"
                      id={`primary-category-tab-${index}`}
                    >
                      {category.icon && (
                        <Isvg
                          aria-hidden="true"
                          src={category.icon}
                          onLoad={() => onSvgLoad(index)}
                        >
                          SVG
                        </Isvg>
                      )}
                      <p>{category.name}</p>
                    </div>
                  </NavItem>
                ))}
              </Nav>
            <Row>
              <Tab.Content animation mountOnEnter unmountOnExit>
                {expressCategories.map((category, index) => {
                  if (category === undefined && category.acadLink === '/')
                    return null
                  return (
                    <Tab.Pane
                      eventKey={`category_${index}`}
                      key={`primarypane_${index}`}
                      mountOnEnter
                      unmountOnExit
                    >
                      <Tab.Container
                        defaultActiveKey={`subcategory_${activeCategoryIndex}_${activeSubcategoryIndex}`}
                        id={`sub-container-${index}`}
                      >
                        <div>
                          <Row>
                            <Nav bsClass="nav nav-pills nav-sub">
                              {category.children.map(
                                (subcategory, subindex) => (
                                  <NavItem
                                    componentClass="a"
                                    eventKey={`subcategory_${index}_${subindex}`}
                                    key={`sub_${subindex}`}
                                    onClick={() =>
                                      onSubNavClick(
                                        index,
                                        subindex,
                                        subcategory
                                      )
                                    }
                                    onKeyDown={e =>
                                      onSubNavKeyPress(index, subindex, e)
                                    }
                                  >
                                    <div
                                      tabIndex="1"
                                      className="sub-category-tab"
                                    >
                                      {subcategory.name}
                                    </div>
                                  </NavItem>
                                )
                              )}
                            </Nav>
                          </Row>
                          {showAdTop && (
                            <AirfindAd
                              id="ad-express"
                              show={showAdTop}
                              style={{ marginBottom: '20px' }}
                            />
                          )}
                          <Row>
                            <Tab.Content animation mountOnEnter unmountOnExit>
                              {category.children.map(
                                (subcategory, subindex) => (
                                  <Tab.Pane
                                    eventKey={`subcategory_${index}_${subindex}`}
                                    key={`subpane_${subindex}`}
                                    mountOnEnter
                                    unmountOnExit
                                  >
                                    <PanelGroup
                                      id="tabcontent-panel"
                                      accordion
                                      bsClass="panel-group faq-list"
                                      defaultActiveKey={`faq_${faqId}`}
                                    >
                                      {subcategory.children
                                        .filter(faq => !!faq.name)
                                        .map((faq, faqindex) => (
                                          <Panel
                                            eventKey={`faq_${faq.pk}`}
                                            key={`subfaq_${faqindex}`}
                                            data-slug={slugify(faq.name)}
                                          >
                                            <Panel.Heading>
                                              <Panel.Title>
                                                <Panel.Toggle
                                                  tabIndex="1"
                                                  componentClass="a"
                                                >
                                                  {faq.name}
                                                </Panel.Toggle>
                                              </Panel.Title>
                                            </Panel.Heading>
                                            <Panel.Collapse
                                              onEnter={() =>
                                                onFaqSelect(faq, category.name)
                                              }
                                            >
                                              <Panel.Body>
                                                <ContentFilter text={faq.val} />
                                                <QuickFeedback
                                                  type="landing"
                                                  contentId={faq.pk}
                                                  createUserEvent={
                                                    createUserEvent
                                                  }
                                                />
                                              </Panel.Body>
                                            </Panel.Collapse>
                                          </Panel>
                                        ))}
                                    </PanelGroup>
                                  </Tab.Pane>
                                )
                              )}
                            </Tab.Content>
                          </Row>
                        </div>
                      </Tab.Container>
                    </Tab.Pane>
                  )
                })}
                <MoreHelpFooterContainer />
              </Tab.Content>
            </Row>
          </div>
        </Tab.Container>
      </Wrapper>
    </div>
  )
}

ExpressContent.propTypes = {
  params: PropTypes.object.isRequired,
  currentPhone: PropTypes.object,
  toggleDeviceModal: PropTypes.func.isRequired,
  query: PropTypes.object.isRequired,
  createUserEvent: PropTypes.func.isRequired,
  expressCategories: PropTypes.array.isRequired,
  location: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  getOption: PropTypes.func.isRequired,
  customer: PropTypes.string.isRequired
}

export default withTheme(OptionsHOC(ExpressContent))



// WEBPACK FOOTER //
// ./src/components/ExpressHelp/ExpressContent.js